import { ListItem, MenuItem } from "@mui/material";
import {
  brandPrimary70,
  darkModeTextColor,
  lightNeutral100,
  lightNeutral60,
  lightNeutral70,
  lightTextBody,
} from "constants/colors";
import styled from "styled-components/macro";

export const ProcessTilesFilterControlsStyles = styled.div<{
  $isDarkMode: boolean;
  $isPending: boolean;
}>`
  *:not(.btnProcessTilesDropdown) {
    overflow: visible !important;
  }
  display: flex;
  flex-grow: 1;
  ${p => (p.$isPending ? `opacity:0.5;` : "")}
  .MuiButtonBase-root {
    color: ${p => (p.$isDarkMode ? darkModeTextColor : "black")};
    text-transform: none;
    border: 1px solid
      ${p => (p.$isDarkMode ? darkModeTextColor : lightNeutral70)};
    border-radius: 8px;
    padding: 5px 10px;
    font-size: 14px;
    line-height: 1px;
  }
  & > div:not(:last-child) {
    margin-right: 10px;
  }
  .btnProcessTilesDropdown {
    overflow: hidden;
    margin-left: 16px;
    &:first-child {
      margin-left: 0;
    }
    .MuiSvgIcon-root {
      background: rgba(65, 108, 226, 0.08);
      padding: 4px;
      margin: -5px;
      border-radius: 4px;
      margin-left: 0px;
    }
    .MuiButton-startIcon .MuiSvgIcon-root {
      padding: 0;
      background: none;
      margin-left: 0px;
      opacity: 0.5;
    }
    &.active {
      background: rgba(65, 108, 226, 0.16);
    }
    background: rgba(65, 108, 226, 0.08);
  }
  .searchInput {
    margin-left: 16px;
    flex-grow: 1;
    fieldset {
      border-radius: 4px;
      border: 1px solid ${lightNeutral70};
    }

    .MuiInputBase-root {
      height: 30px;
      align-content: center;
    }
    .MuiAutocomplete-inputRoot {
      padding-right: 8px !important;
    }
    .MuiInputBase-input {
      padding: 0;
      font-size: 14px;
      color: ${lightNeutral100};
    }
    .btnClearInput {
      border: none;
      padding: 0;
      margin-right: -10px;
      color: ${lightTextBody};
    }
    .MuiSvgIcon-root {
      width: 20px;
      height: 20px;
      margin-right: 10px;
      margin-left: 4px;
    }
  }
  @media (max-width: 400px) {
    .MuiButton-startIcon {
      display: none;
    }
  }
`;
export const StyledOption = styled(ListItem)`
  cursor: pointer;
  width: 100%;
  padding-left: 10px;
  display: flex;
  align-items: center;
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
  .Mui-checked .MuiSvgIcon-root {
    color: ${brandPrimary70};
  }
  &,
  .MuiCheckbox-root {
    border: none;
  }
  .MuiCheckbox-root {
    width: 42px;
    height: 42px;
    padding: 0;
    margin-right: 10px;
  }
  && .MuiSvgIcon-root {
    margin: 0;
    width: 1em;
    height: 1em;
  }
  &.disabled {
    opacity: 0.5;
    cursor: default;
  }
`;
export const StyledMenuItemFilterControls = styled(MenuItem)`
  font-family: "Open Sans", sans-serif;
  padding: 0px 10px 0px 24px;
  height: 48px;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  /* For menu items that need to open submenus on hover */
  &.hover-open-submenu {
    position: relative;
  }
  &.selectAll {
    font-weight: bold;
  }
  &.selected {
    background: rgba(65, 108, 226, 0.08);
  }
  .label {
    min-width: 144px;
  }
  .circle {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 16px;
  }
  .MuiCheckbox-root {
    margin-left: auto;
  }
  .Mui-checked .MuiSvgIcon-root {
    color: ${brandPrimary70};
  }
  .sortArrowButton {
    .MuiSvgIcon-root {
      color: ${lightNeutral60};
    }
    &.active {
      .MuiSvgIcon-root {
        color: ${lightNeutral100};
      }
    }
    padding: 4px;
  }
`;
